import { Settings } from "../../api";

export const FETCH_SETTINGS = "FETCH_SETTINGS";

export interface FetchSettingsAction {
  type: typeof FETCH_SETTINGS;
}
interface SetSettingsAction {
  type: "SET_SETTINGS";
  data: Settings;
}
interface SetSettingsLoadingAction {
  type: "SET_SETTINGS_LOADING";
}
interface SetSettingsErrorAction {
  type: "SET_SETTINGS_ERROR";
}

export type KnownActions =
  | FetchSettingsAction
  | SetSettingsAction
  | SetSettingsLoadingAction
  | SetSettingsErrorAction;

export const fetchSettings = (): FetchSettingsAction =>
  ({ type: "FETCH_SETTINGS" });

export const setSettings = (
  data: Settings
): SetSettingsAction =>
  ({ type: "SET_SETTINGS", data });

export const setSettingsLoading = (): SetSettingsLoadingAction =>
  ({ type: "SET_SETTINGS_LOADING" });

export const setSettingsError = (): SetSettingsErrorAction =>
  ({ type: "SET_SETTINGS_ERROR" });
